module.exports = __webpack_public_path__ + "static/img/deve9.8d906af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deve9.png
// module id = CHxj
// module chunks = 1